export default {

    props: ['entrypoint'],

    data: () => ({
        count: 0,
    }),

    methods: {
        increment(amount = null) {
            this.$jmp.notifySuccess('foo')
            // window.EventBus.$emit('notify', { message: { icon: 'mdi-information', text: 'Incremented' }, color: 'blue' })
            if (null !== amount) {
                return this.count += amount
            }
            this.count++
        },
        decrement(amount = null) {
            window.EventBus.$emit('notify', { message: { icon: 'mdi-information', text: 'Decremented' }, color: 'orange' })
            if (null !== amount) {
                return this.count -= amount
            }
            this.count--
        },
    },

    render(h) {
        return this.$scopedSlots.default({
            count: this.count,
            increment: this.increment,
            decrement: this.decrement,
            entrypoint: this.entrypoint,
        })
    },
}
